module.exports = __webpack_public_path__ + "static/img/167_phase_function_Paper_Points.5c9cbb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/167_phase_function_Paper_Points.png
// module id = wGEL
// module chunks = 0